import type PricingRoom from '@app/model/pricing-automation/PricingRoom';

export const pricingRoomName = (room: Pick<PricingRoom, 'roomName' | 'rateType'>): string =>
	room.rateType ? `${room.roomName} (${room.rateType})` : room.roomName;
